export const getDataSourceExcelOperationId = (dataSourceId: string): string => `data-source-${dataSourceId}-excel`
